import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import toast from "react-hot-toast";
import SelectMenu from "../SelectMenu";
import TableFilterAcionts from "../TableFilterAcionts";

interface IProps {
  filter: IFilter;
  setFilter: (filter: IFilter) => void;
  handleSearch: (filter?: IFilter) => void;
}

interface IFilter {
  status: boolean;
  data: {
    user_details: string;
    wallet_address: string;
    status: string;
    date_from: string;
    date_to: string;
  };
}
const initFilterData: IFilter = {
  status: true,
  data: {
    user_details: "",
    wallet_address: "",
    date_from: "",
    date_to: "",
    status: "",
  },
};

export default function FilterForm({
  filter,
  setFilter,
  handleSearch,
}: IProps) {
  const handleChanges = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({
      ...filter,
      data: {
        ...filter.data,
        [event.target.name]: event.target.value,
      },
    });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
        <SelectMenu
          label="Status"
          handleChange={({ target }) => {
            setFilter({
              ...filter,
              data: {
                ...filter.data,
                status: target.value,
              },
            });
          }}
          options={[
            { value: "", label: "Status" },
            { value: "Registered", label: "Registered" },
            { value: "Pending", label: "Pending" },
            { value: "Rejected", label: "Rejected" },
            { value: "Active", label: "Active" },
            { value: "Inactive", label: "Inactive" },
          ]}
          value={filter.data.status}
          sx={{ flex: "1 1 400px" }}
        />
        <TextField
          label="Wallet Address"
          variant="standard"
          value={filter.data.wallet_address}
          name="wallet_address"
          onChange={handleChanges}
          sx={{ flex: "1 1 400px" }}
        />
        <TextField
          variant="standard"
          id="date"
          label="From"
          value={moment(filter.data.date_from, "MM/DD/YYYY").format(
            "YYYY-MM-DD"
          )}
          name="date_from"
          type="date"
          InputLabelProps={{ shrink: true }}
          sx={{ flex: "1 1 400px" }}
          onChange={(event) => {
            if (filter.data.date_to) {
              if (
                moment(event.target.value, "YYYY-MM-DD").isSameOrAfter(
                  filter.data.date_to
                )
              ) {
                toast.error("From date must be before To date");

                return;
              } else {
                setFilter({
                  ...filter,
                  data: {
                    ...filter.data,
                    date_from: moment(event.target.value).format("MM/DD/YYYY"),
                  },
                });
              }
            } else {
              setFilter({
                ...filter,
                data: {
                  ...filter.data,
                  date_from: moment(event.target.value).format("MM/DD/YYYY"),
                },
              });
            }
          }}
        />
        <TextField
          variant="standard"
          id="date"
          label="To"
          value={moment(filter.data.date_to, "MM/DD/YYYY").format("YYYY-MM-DD")}
          name="date_to"
          type="date"
          InputLabelProps={{ shrink: true }}
          sx={{ flex: "1 1 400px" }}
          onChange={(event) => {
            if (filter.data.date_from) {
              if (
                moment(event.target.value, "YYYY-MM-DD").isSameOrAfter(
                  filter.data.date_from
                )
              ) {
                setFilter({
                  ...filter,
                  data: {
                    ...filter.data,
                    date_to: moment(event.target.value).format("MM/DD/YYYY"),
                  },
                });
              } else {
                toast.error("Date to must be greater than date from");
              }
            } else {
              setFilter({
                ...filter,
                data: {
                  ...filter.data,
                  date_to: moment(event.target.value).format("MM/DD/YYYY"),
                },
              });
            }
          }}
        />
        <TextField
          label="Full Name, Email or Mobile"
          variant="standard"
          value={filter.data.user_details}
          name="user_details"
          onChange={handleChanges}
          sx={{ flex: "1 1 400px" }}
        />
      </Box>
      <TableFilterAcionts
        disableCancel={false}
        handleClearSearch={() => {
          setFilter(initFilterData);

          handleSearch(initFilterData);
        }}
        handleSearch={handleSearch}
      />
    </Box>
  );
}
